import { render, staticRenderFns } from "./SpaceThemePicker.vue?vue&type=template&id=3c212851&scoped=true&"
import script from "./SpaceThemePicker.vue?vue&type=script&lang=js&"
export * from "./SpaceThemePicker.vue?vue&type=script&lang=js&"
import style0 from "./SpaceThemePicker.vue?vue&type=style&index=0&id=3c212851&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c212851",
  null
  
)

export default component.exports